export enum AzureADRoles {
	All = "role.admin,role.fulluser,role.requester",
	AdminOrFullUser = "role.admin,role.fulluser",
	Admin = "role.admin",
	FullUser = "role.fulluser",
	Requester = "role.requester"
};
